import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useParams } from "react-router-dom"; // Import useParams to get URL parameters
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  GetAllBeneficiary,
  GetExecutor,
  GetGuadinaSetList,
  GetGuardianList,
} from "../../api/get";
import Modal from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { AddBeneficiary, SaveExecutor, SaveGuardianList } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { FaInfoCircle } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const GuardianList = () => {
  const [beneficiaries, setBeneficiaryList] = useState([]);
  const [refreshBenficiary, setRefreshBenficiary] = useState(false);
  const [openModal, setOpenModal] = useState();
  const [addBeneficiary, setaddBeneficiary] = useState([]);
  const [guardianSetList, setGuardianSetList] = useState([]);
  const [findDataChild, setFindDataChild] = useState();
  const [saveGuardian, setSaveGuardian] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contentLoder, setContentLoader] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, type } = useParams(); // Extract 'id' and 'type' from URL
  const [selectedItem, setSelectedItem] = useState(null); // State for storing selected child/pet
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false); // New state for Next button
  const [addButtonDisable, setaddButtonDisable] = useState(false);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const onCloseGuardianModel = () => {
    setOpenModal(false);
    formikAddGuardian.resetForm(); // Reset the form on modal close
  };
  const formatDateToYMD = (dob) => {
    if (!dob || dob === "undefined" || dob.trim() === "") {
      return ""; // Return an empty string if the input is invalid
    }

    // Assuming `dob` is in "dd/mm/yyyy" format
    const [day, month, year] = dob.split("/");

    if (!day || !month || !year) {
      return ""; // Return empty if any part is missing
    }

    return `${year}-${month}-${day}`; // Convert to "yyyy-mm-dd"
  };
  useEffect(() => {
    if (id && type) {
      // Ensure id and type are defined before fetching data
      console.log("URL Params: ", id, type);
      // Fetch guardian set list
      GetGuadinaSetList()
        .then((res) => {
          if (res.success && res.status_code === "200") {
            const { child, pets } = res.data; // Extract child and pets from the API response
            // Find the matching item based on id and type
            let matchingItem = null;
            if (type === "child") {
              matchingItem = child.find((item) => item.id === parseInt(id));
            } else if (type === "pet") {
              matchingItem = pets.find((item) => item.id === parseInt(id));
            }
            console.log("matchingItem =>", matchingItem);
            setSelectedItem(matchingItem); // Set the matched item to state
            // console.log("Selected Item: ", matchingItem);
            // Optionally, call GetGuardianList if further data is needed
            return GetGuardianList(id, type);
          } else {
            handleApiError(res, navigate);
          }
        })
        .then((res) => {
          setBeneficiaryList(res.data);
        })
        .catch((err) => {
          console.error("Error fetching data: ", err);
        })
        .finally(() => {
          setContentLoader(false);
        });
    }
  }, [id, type]);

  const formik = useFormik({
    initialValues: {
      beneficiaries:
        beneficiaries.length > 0
          ? beneficiaries.map((b) => ({
              id: b.id,
              isSelected: b.is_selected || false,
            }))
          : [], // Handle empty state
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      beneficiaries: Yup.array().of(
        Yup.object({
          id: Yup.number().required(),
          isSelected: Yup.boolean(),
        })
      ),
    }),
    onSubmit: async (values) => {
      try {
        const selectedGuardians = values.beneficiaries
          .filter((beneficiary) => beneficiary.isSelected)
          .map((beneficiary) => beneficiary.id);
        const requestData = { child_or_pet: type, child_or_pet_id: id };
        if (selectedGuardians.length > 0) {
          requestData.guardian_ids = selectedGuardians;
        }
        const response = await SaveGuardianList(requestData);
        toast.success("guardian save successfully");
        // console.log("response",response);

        // Navigate to the next route if the save is successful
        if (selectedItem && selectedItem.next_id) {
          navigate(
            `/guardian/review/list/${selectedItem.next_id}/${selectedItem.child_or_pet}`
          );
        } else {
          console.warn("No next item available to navigate to.");
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    },
  });

  // Check if at least one checkbox is selected
  useEffect(() => {
    const hasSelected = formik.values.beneficiaries.some(
      (b) => b.isSelected === true
    );
    setIsNextButtonEnabled(hasSelected);
    const selectedCount = formik.values.beneficiaries.filter(
      (b) => b.isSelected
    ).length;
    if (selectedCount > 4) {
      setIsNextButtonEnabled(false);
    } else if (selectedCount >= 4) {
      setaddButtonDisable(true);
    } else {
      setaddButtonDisable(false);
    }
  }, [formik.values.beneficiaries]);

  useEffect(() => {
    formik.setValues({
      beneficiaries: beneficiaries.map((b) => ({
        id: b.id,
        isSelected: b.is_selected || false,
      })),
    });
  }, [beneficiaries]);
  console.log("beneficiaries =>", beneficiaries);

  const validationSchemaForGuardian = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your Guardian needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
    // location:
  });
  const formikAddGuardian = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_email: "",
      beneficiary_dob: "",
      beneficiary_location: "",
    },
    validationSchema: validationSchemaForGuardian, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      console.log("values  =>", values);
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        beneficiary_dob: values.beneficiary_dob
          ? formatDateToYMD(values.beneficiary_dob)
          : "", // Handle empty or invalid input
      };
      console.log("transformedValues  =>", transformedValues);
      // setRefreshBenficiary(false);
      AddBeneficiary(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            const newBeneficiary = res.data;
            var data = {
              beneficiary_first_name: newBeneficiary.beneficiary_first_name,
              beneficiary_last_name: newBeneficiary.beneficiary_last_name,
              beneficiary_type: "other",
              guardianFor: "",
              id: newBeneficiary.id,
              is_selected: true,
            };
            // Append new beneficiary to the list
            setBeneficiaryList((prev) => [...prev, data]);
            // Update Formik values
            formik.setFieldValue("beneficiaries", [
              ...formik.values.beneficiaries,
              {
                id: newBeneficiary.id,
                isSelected: false, // Default value for isSelected
                ...newBeneficiary, // Add other returned data
              },
            ]);
            toast.success("guardian Added Successfully");
            setOpenModal(false);
            resetForm(); // This will clear the form fields
          } else {
            handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1 mt-[30px]">
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <p className="text-[26px] font-semibold">
                    Choose guardians for{" "}
                    {selectedItem?.current_type === "child"
                      ? selectedItem?.beneficiary_first_name
                      : selectedItem?.pet_name}
                  </p>
                  <p className="my-3 text-slate-500">
                    You can choose up to 4 guardians for{" "}
                    {selectedItem?.current_type === "child"
                      ? selectedItem?.beneficiary_first_name
                      : selectedItem?.pet_name}
                    .
                  </p>
                  <div className="text-[22px] font-semibold mt-4">
                    Choose guardians
                  </div>
                  {addButtonDisable && (
                    <div className="text-[18px] font-semibold mt-4 bg-[#f44336] text-white p-3 rounded">
                      You can select up to 4 guardians. Delete a guardian if you
                      would like to add another guardian.
                    </div>
                  )}
                  {beneficiaries.map((beneficiary, index) => (
                    <div
                      key={beneficiary.id}
                      className={`my-5 border-2 pb-3 px-4 GuardianDiv ${
                        formik.values.beneficiaries[index]?.isSelected
                          ? "blueBorder"
                          : `border-[#d7d7d7] ${
                              addButtonDisable
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`
                      } 
                    `}
                      onClick={() => {
                        // Toggle the checkbox on div click
                        setBeneficiaryList((prevList) =>
                          prevList.map((beneficiary, idx) =>
                            idx === index
                              ? {
                                  ...beneficiary,
                                  is_selected: !beneficiary.is_selected,
                                }
                              : beneficiary
                          )
                        );
                        formik.setFieldValue(
                          `beneficiaries[${index}].isSelected`,
                          !formik.values.beneficiaries[index]?.isSelected
                        );
                      }}
                    >
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5">
                          <div>
                            <img
                              src="/assets/images/icon-mascot.png"
                              alt="Icon Mascot"
                            />
                          </div>
                          <div>
                            <h4 className="text-[18px] font-semibold">
                              {beneficiary.beneficiary_first_name}{" "}
                              {beneficiary.beneficiary_last_name}
                            </h4>
                            {beneficiary.beneficiary_type && (
                              <p>
                                Your {beneficiary.beneficiary_type}
                                {beneficiary.guardianFor?.length > 0 &&
                                  `, Guardian for: ${beneficiary.guardianFor
                                    .map(
                                      (guardian) =>
                                        `${guardian.name} ${
                                          guardian.type === "pet"
                                            ? `(${guardian.pet_type})`
                                            : ""
                                        }
                                            `
                                    )
                                    .join(", ")}`}
                              </p>
                            )}
                          </div>
                        </div>
                        <div>
                          <input
                            name={`beneficiaries[${index}].isSelected`}
                            type="checkbox"
                            className={`w-[20px] h-[20px]
                              ${
                                addButtonDisable && !beneficiary.is_selected
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }
                              `}
                            checked={
                              formik.values.beneficiaries[index]?.isSelected ||
                              false
                            }
                            onChange={(e) => {
                              e.stopPropagation(); // Prevent the parent div's onClick from firing
                              formik.setFieldValue(
                                `beneficiaries[${index}].isSelected`,
                                e.target.checked
                              );
                            }}
                            disabled={
                              addButtonDisable && !beneficiary.is_selected
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="my-5 border-b-2 pb-5">
                    <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5">
                          <div>
                            <img src="/assets/images/icon-mascot.png" />
                          </div>
                          <div>
                            <h4 className="text-[16px] text-black font-muli font-bold ">
                              Add a new guardian
                            </h4>
                            <p>
                              Add someone new to look after{" "}
                              {selectedItem?.current_type === "child"
                                ? selectedItem?.beneficiary_first_name
                                : selectedItem?.pet_name}
                            </p>
                          </div>
                        </div>
                        <div>
                          <Link>
                            <button
                              onClick={() => setOpenModal(true)}
                              disabled={addButtonDisable}
                              className={`border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold
                                ${
                                  addButtonDisable
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }        
                                `}
                            >
                              Add
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between my-5">
                    {selectedItem.previous_id === 0 ? (
                      <button
                        onClick={() => navigate("/dashboard")}
                        className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft /> Back
                      </button>
                    ) : (
                      <Link
                        to={`/guardian/review/list/${selectedItem.previous_id}/${selectedItem.previous_child_or_pet}`}
                      >
                        <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                          <FaAngleLeft /> Back
                        </button>
                      </Link>
                    )}
                    <button
                      type="submit"
                      className={`bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2 ${
                        isNextButtonEnabled
                          ? ""
                          : "opacity-50 cursor-not-allowed"
                      }`}
                      disabled={!isNextButtonEnabled} // Disable button if no checkbox is selected
                    >
                      Next
                    </button>
                  </div>
                </div>
              </form>
              <div>
                <div className="bg-no-repeat max-lg:hidden">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/9.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <Modal
        open={openModal}
        onClose={onCloseGuardianModel}
        center
        classNames={{
          modal: "rounded-[5px] p-5", // Add the rounded class here along with padding
        }}
      >
        <div className="px-5">
          <form onSubmit={formikAddGuardian.handleSubmit}>
            <div>
              <div>
                <h4 className="text-[26px] text-black font-bold mt-[10px]">
                  Add a new guardian
                </h4>
              </div>
              <div className="grid grid-cols-2 gap-5 ">
                <div className="mt-5 mb-4 ">
                  <FloatingLabelInput
                    label="First Name"
                    type="text"
                    id="first_name"
                    name="beneficiary_first_name"
                    value={formikAddGuardian.values.beneficiary_first_name}
                    onChange={formikAddGuardian.handleChange}
                    onBlur={formikAddGuardian.handleBlur}
                    error={
                      formikAddGuardian.touched.beneficiary_first_name &&
                      formikAddGuardian.errors.beneficiary_first_name
                    }
                  />
                </div>

                <div className="mt-5 mb-4 ">
                  <FloatingLabelInput
                    label="Last Name"
                    type="text"
                    id="last_name"
                    name="beneficiary_last_name"
                    value={formikAddGuardian.values.beneficiary_last_name}
                    onChange={formikAddGuardian.handleChange}
                    onBlur={formikAddGuardian.handleBlur}
                    error={
                      formikAddGuardian.touched.beneficiary_last_name &&
                      formikAddGuardian.errors.beneficiary_last_name
                    }
                  />
                </div>
              </div>
              <div className="mt-1 mb-4 ">
                <FloatingLabelInput
                  label="Email address (optional)"
                  type="text"
                  id="new_guardian_email"
                  name="beneficiary_email"
                  value={formikAddGuardian.values.beneficiary_email}
                  onChange={formikAddGuardian.handleChange}
                  onBlur={formikAddGuardian.handleBlur}
                  error={
                    formikAddGuardian.touched.beneficiary_email &&
                    formikAddGuardian.errors.beneficiary_email
                  }
                />
              </div>
              <div className="w-full mt-5">
                <div className="relative w-full border-2 h-[60px] flex items-center">
                  <MaskedInput
                    mask={[
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      "/",
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    placeholder={
                      isFocused || formikAddGuardian.values.beneficiary_dob
                        ? "dd/mm/yyyy"
                        : ""
                    }
                    pipe={autoCorrectedDatePipe}
                    value={formikAddGuardian.values.beneficiary_dob}
                    onFocus={() => setIsFocused(true)}
                    onBlur={(e) => {
                      setIsFocused(false);
                      formikAddGuardian.handleBlur(e); // To ensure Formik registers field as "touched"
                    }}
                    onChange={(e) => {
                      formikAddGuardian.setFieldValue(
                        "beneficiary_dob",
                        e.target.value
                      );
                    }}
                    className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                    name="beneficiary_dob"
                  />

                  <label
                    htmlFor="dob"
                    className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                  >
                    Date of birth(optional)
                  </label>
                </div>
              </div>
              {formikAddGuardian.touched.beneficiary_dob &&
              formikAddGuardian.errors.beneficiary_dob ? (
                <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                  <FaInfoCircle />
                  <p className="text-white py-1 px-2 text-sm my-2">
                    {formikAddGuardian.errors.beneficiary_dob}
                  </p>
                </div>
              ) : null}

              <div>
                <h4 className="text-[16px] text-black font-bold mt-[36px]">
                  Add their address
                </h4>
                <p className="text-slate-500 my-2">
                  Adding address is optional
                </p>
              </div>
              <div className="mt-1 mb-4 ">
                <FloatingLabelInput
                  label="Enter their full address"
                  type="text"
                  id="beneficiary_location"
                  name="beneficiary_location"
                  value={formikAddGuardian.values.beneficiary_location}
                  onChange={formikAddGuardian.handleChange}
                  onBlur={formikAddGuardian.handleBlur}
                />
              </div>
              <div className="flex justify-between">
                <div className="py-5 ">
                  {!loading ? (
                    <button
                      type="submit"
                      className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                    >
                      Add guardian
                    </button>
                  ) : (
                    <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                      <Spinner />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default GuardianList;
